var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"view-pic-svg",attrs:{"role":"img","viewBox":_vm.svgViewBox,"aria-hidden":_vm.ariaHiddenValue}},[(_vm.renderedTitle)?_c('title',[_vm._v(_vm._s(_vm.renderedTitle))]):_vm._e(),_vm._v(" "),_c('use',{attrs:{"xlink:href":_vm.svgPath}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6060490","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/snippets/PicSvg.vue
// module id = 412
// module chunks = 0